import React from 'react'
import faild from "../../assets/images/FailedAge.svg"
import { Link } from 'react-router-dom'
const Faild = () => {
    return (
        <div className='faild'>
            <img src={faild} alt="" />
            <div className="BTNS">
                <Link to="/AgeVerification">Try Again</Link>
            {/* <Link to="/AgeVerification" className='Cancel'>Cancel</Link> */}
            </div>
        </div>
    )
}

export default Faild